import { _Vue } from './index';
import PopupCaptchaComp from './popup-captcha.vue';
import { t } from '../../locale';

let popup = null;
let callback = null;

let _uid = 0;

const captChaTypeMap = {
  hcaptcha: 'checkbox',
  recaptcha: 'checkbox',
  smart: 'input'
};

function uid() {
  return _uid++;
}

export default function createPopupCaptcha(options, next) {
  if (!popup) {
    popup = new PopupCaptcha(options);
  } else {
    popup.update(options);
  }
  callback = next;
  return popup;
}

class PopupCaptcha {
  constructor({ type, routingUrl, errorMessage }) {
    this.type = captChaTypeMap[type] || 'input';
    this.routingUrl = routingUrl;
    this.errorMessage = errorMessage;
    this.isHcaptcha = type === 'hcaptcha';
    this.render();
  }

  render() {
    const vm = this.vm = new _Vue();
    this.popupCaptchaVNode = vm.$createElement(PopupCaptchaComp, {
      key: uid()
    });
    vm.$msgbox({
      title: t('popup-captcha.title'),
      message: this.popupCaptchaVNode,
      showConfirmButton: false,
      closeOnClickModal: false,
      callback: () => {
        popup = null;
      }
    });
    _Vue.nextTick(() => {
      this.popupCaptchaInstance = this.popupCaptchaVNode.componentInstance;

      this.updateInstance();
      this.popupCaptchaInstance.$on('validate', (captcha) => {
        callback && callback(captcha);
      });
    });
  }

  update({ type, routingUrl, errorMessage }) {
    this.type = captChaTypeMap[type] || 'input';
    this.routingUrl = routingUrl;
    this.errorMessage = errorMessage;
    this.isHcaptcha = type === 'hcaptcha';

    this.updateInstance();

    this.popupCaptchaInstance.refresh();
  }

  updateInstance() {
    this.popupCaptchaInstance.type = this.type;
    this.popupCaptchaInstance.routingUrl = this.routingUrl;
    this.popupCaptchaInstance.errorMessage = this.errorMessage;
    this.popupCaptchaInstance.isHcaptcha = this.isHcaptcha;
  }

  hide() {
    popup = null;
    this.vm.$msgbox.close();
  }
}
